import styled from "styled-components";
import FormLabel from "../FormLabel";

const HintText = styled(FormLabel)`
  color: ${(p) => p.theme.colors.neutral5};
  margin-top: 8px;
  font-weight: 400;
  margin-bottom: 8px;
`;

export default HintText;
